<template>
  <div ref="searchRootRef" class="navbar-search">
    <div
      class="navbar-search__bar"
      :class="{ 'navbar-search__bar--focused': isFocused }"
      @click="handleBarClick"
    >
      <input
        ref="inputRef"
        v-model="searchText"
        type="text"
        class="navbar-search__input"
        placeholder="  搜索你想看的漫画吧..."
        autocomplete="off"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="performSearch()"
      />
      <button
        type="button"
        class="navbar-search__submit"
        aria-label="搜索"
        @mousedown.prevent
        @click="performSearch()"
      >
        <AppIcon name="search" size="sm" aria-label="" />
      </button>
    </div>

    <div
      v-if="isDropdownVisible && historyList.length > 0"
      class="navbar-search__dropdown"
      @mousedown.prevent="keepDropdownOpen"
    >
      <ul class="navbar-search__list" role="list">
          <li
            v-for="item in historyList"
            :key="item.id"
            class="navbar-search__item"
          >
            <button
              type="button"
              class="navbar-search__keyword"
              :title="item.keyword"
              @click="selectHistoryItem(item)"
            >
              {{ item.keyword }}
            </button>
            <button
              type="button"
              class="navbar-search__delete"
              aria-label="删除搜索记录"
              @click.stop="deleteHistoryItem(item)"
            >
              <AppIcon name="close" size="xs" aria-label="删除搜索记录" />
            </button>
          </li>
        </ul>

        <div v-if="showHistoryFooter" class="navbar-search__footer">
          <button
            v-if="canLoadMore"
            type="button"
            class="navbar-search__action navbar-search__action--more"
            @click="loadMoreHistory"
          >
            显示更多
          </button>
          <span v-else class="navbar-search__footer-spacer"></span>
          <button
            v-if="showClearAll"
            type="button"
            class="navbar-search__action navbar-search__action--clear"
            @click="clearAllHistory"
          >
            清空记录
          </button>
        </div>
    </div>
  </div>
</template>

<script setup>
import AppIcon from '@/shared/components/AppIcon.vue'
import { useNavBarSearch } from '@/shared/composables/useNavBarSearch'

const props = defineProps({
  authToken: {
    type: String,
    default: '',
  },
})

const {
  searchText,
  isFocused,
  isDropdownVisible,
  historyList,
  canLoadMore,
  showHistoryFooter,
  showClearAll,
  searchRootRef,
  handleFocus,
  handleBlur,
  handleBarClick,
  keepDropdownOpen,
  performSearch,
  selectHistoryItem,
  deleteHistoryItem,
  loadMoreHistory,
  clearAllHistory,
} = useNavBarSearch(props)
</script>

<style scoped src="@/shared/styles/NavBarSearch.css"></style>
